import React, { useState } from 'react';
import UbicationServices from '../services/ubications_services';
import {
    geocodeByAddress,
} from 'react-places-autocomplete';
  
const SelectPlace: React.FC<{ onChange(response: string): void }> = (props) => {
    const [results, setResults] = useState<string[]>(null);

    var timer: NodeJS.Timeout;
    const handleChange = (text: string) => {
        if (timer !== null) {
            timer = null;
            return;
        }

        timer = setTimeout(async () => {
            const response = await geocodeByAddress(text + ", Mexico");
            setResults(
                response.map(element => element.formatted_address)
            );
        }, 800);
    }

    const renderResults = () => {
        if (!!results) {
            return (
                <div className="results">
                    {
                        results.map<JSX.Element>(element => {
                            return (
                                <div className="card" style={{
                                    display: "flex",
                                    justifyContent: 'space-between',
                                    padding: 15,
                                    alignItems: "center"
                                }}
                                    key={Math.random()}
                                    onClick={() => props.onChange(element)}
                                >
                                    <p style={{ marginRight: 5 }}>{element}</p>
                                    <span className="icon">
                                        <i className="fas fa-hand-pointer"></i>
                                    </span>
                                </div>
                            );
                        })
                    }
                </div>
            );
        }

        return (<></>);
    }

    return (
        <div id="container-modal-view">
            <input type="text" className="input" placeholder="Buscar por Nombre" onChange={(e)=> handleChange(e.target.value)}/>
            <div className="content-search" style={{ textAlign: "left", marginTop: 10 }}>
                <h6 className="title is-6" style={{ marginBottom: 10 }}>Resultados</h6>
                {renderResults()}
            </div>
        </div>
    );
}

export default SelectPlace;